<nb-card class="delete-dialog">
  <nb-card-header>
    <nb-icon (click)="closeDialog()" icon="close-outline"></nb-icon>
    حذف گروه داشبوردی
  </nb-card-header>
  <nb-card-body>
    <div style="line-height: 1rem">
      آیا از حذف گروه داشبوردی "{{ asset?.name }}" اطمینان دارید؟
    </div>
    <div>با حذف گروه داشبوردی داشبوردهای درون آن نیز حذف خواهندشد.</div>
  </nb-card-body>
  <div class="nb-card-footer">
    <button nbButton (click)="closeDialog()" class="cancle-button">
      انصراف
    </button>
    <button nbButton (click)="onDeleteClick()" class="delete-button">
      حذف
    </button>
  </div>
</nb-card>